module.exports = __webpack_public_path__ + "static/img/index-c_bg02.79e8f31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/index-c_bg02.png
// module id = zRjM
// module chunks = 1